module.exports = __webpack_public_path__ + "img/banner_mobile.248cf85d.jpg";